<template>
  <div class="view-component-loader">
    <v-container>
      <v-layout flex align-center justify-center>
        <v-progress-circular
          :indeterminate="true"
          :size="35"
          :width="5"
          color="orange" />
        <span v-if="label" class="view-component-loader--label">{{label}}</span>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/vars/theme';
@import '../../styles/vars/typography';

.view-component-loader {
  padding: 20px;

  &--label {
    color: lighten(#4f4f4f, 19.22);
    display: inline-block;
    font-size: 1.25rem;
    font-weight: $typography-weight-semibold;
    padding: 0 15px;
  }
}
</style>
